import olStyle from 'ol/style/Style.js';

class Style extends olStyle {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }

    getRotation() {
        return this.rotation_;
    }

}

export default Style;